import React, { useCallback } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from "@mui/material";

export const DeleteRoleDialog = ({ open, loading, onClose, onSubmit }) => {
  const handleClose = useCallback(() => {
    if (!loading) {
      onClose();
    }
  }, [loading, onClose]);

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth="md"
      onClose={handleClose}
      aria-labelledby="Delete-Role-Dialog"
      data-qa="Settings-Delete-Role-Dialog"
    >
      <DialogTitle>Delete a role</DialogTitle>
      <DialogContent>Are you sure you want to delete this role?</DialogContent>
      <DialogActions>
        <Button
          data-qa="Settings-Button-Cancel-Delete-Role"
          variant="outlined"
          color={"primary"}
          disabled={loading}
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          data-qa="Settings-Button-Delete-Role"
          variant="contained"
          color="secondary"
          disabled={loading}
          onClick={onSubmit}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DeleteRoleDialog.propTypes = {
  open: PropTypes.bool,
  loading: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func
};
